// Tree-shaken echarts entry; must be listed in package.json `sideEffects` so webpack preserves the echarts.use() registration below.
import * as echarts from "echarts/core";
import { BarChart, LineChart, PieChart, ScatterChart, BoxplotChart } from "echarts/charts";
import {
	GridComponent,
	TooltipComponent,
	LegendComponent,
	TitleComponent,
	DatasetComponent,
	TransformComponent,
	AxisPointerComponent,
	MarkLineComponent,
	MarkPointComponent,
	MarkAreaComponent,
} from "echarts/components";
import { LabelLayout, UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
import { SVGRenderer } from "echarts/renderers";

echarts.use([
	BarChart,
	LineChart,
	PieChart,
	ScatterChart,
	BoxplotChart,
	GridComponent,
	TooltipComponent,
	LegendComponent,
	TitleComponent,
	DatasetComponent,
	TransformComponent,
	AxisPointerComponent,
	MarkLineComponent,
	MarkPointComponent,
	MarkAreaComponent,
	LabelLayout,
	UniversalTransition,
	CanvasRenderer,
	SVGRenderer,
]);

export { echarts };
export default echarts;